import React from 'react';
import { useField } from '@kizi/comparator-core';
import { P, Span, Div } from '@kizi/core-components';

export interface Option {
  value: string | number;
  label: string;
}
export interface TemplateParagraphWrapper {
  label?: string;
  fieldName: string;
  unit?: string;
  isAddress?: boolean;
  options?: Option[];
}
export interface TemplateParagraphProps {
  label?: string;
  unit?: string;
  value: React.ReactElement;
}

const Paragraph: React.FC = ({ children }) => (
  <Span variant="footnoteRegular" display="block">
    {children}
  </Span>
);

export const TemplateParagraph: React.FC<TemplateParagraphProps> = ({
  value,
  unit,
  label,
}) => {
  // Security class should be there only for cars with a cat value of >50K,
  // then only show security classes that are not equal to 'Klasse 1: Startonderbreker'
  if (value.props.children === 'Klasse 1: Startonderbreker') return null;

  return (
    <Div variant="personalDataTemplateContainer">
      <P variant="footnoteRegular" display="flex" flexWrap="wrap">
        {label && <Span mr={1}>{label}</Span>}
        {value}
        {unit && <Span ml={1}>{unit}</Span>}
      </P>
    </Div>
  );
};

export const TemplateWrapper: React.FC<TemplateParagraphWrapper> = ({
  fieldName,
  label,
  unit,
  isAddress,
  options,
}) => {
  const field = useField(fieldName);

  if (field === undefined) {
    return null;
  }

  const _field = !field.hasOwnProperty('active')
    ? { ...field, active: true }
    : { ...field };
  const { value, active } = _field;

  if (!value || !active) return null;

  let _value = <Span>{value}</Span>;

  if (isAddress) {
    const commaIndex = (value as string).indexOf(',');

    const firstParagraph = (value as string).slice(0, commaIndex - 6);

    const secondParagraph = (value as string).slice(commaIndex - 6);
    _value = (
      <>
        <Paragraph>{firstParagraph}</Paragraph>
        <Paragraph>{secondParagraph}</Paragraph>
      </>
    );
  }

  if (options && options?.length > 0) {
    _value = <Span>{options?.find((x) => x.value == value)?.label}</Span>;
  }

  return <TemplateParagraph value={_value} label={label} unit={unit} />;
};
